import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DeleteIcon from "@mui/icons-material/Delete";
import HistoryIcon from "@mui/icons-material/History";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

interface QuotationActionMenuProps {
  row: any;
  handleDelete?: (id: string, rowData?: any) => void;
  handleDownloadPDF?: (id: string) => void;
  handleDownloadPDF2?: (id: string) => void;
  handlePIInvoice1?: (id: string) => void;
  handlePIInvoice2?: (id: string) => void;
  handleViewModal?: (id: string) => void;
  canChange: boolean;
  canDelete?: boolean; // Add this prop
  handleFollowUpDetails?: (quotationId: string, rowData: any) => void;
}

export const QuotationActionMenu = ({
  row,
  handleDelete,
  handleDownloadPDF,
  handleDownloadPDF2,
  handlePIInvoice1,
  handlePIInvoice2,
  handleViewModal,
  canChange,
  canDelete = false, // Add this with default value false
  handleFollowUpDetails,
}: QuotationActionMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <button
        onClick={handleClick}
        style={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
        }}
      >
        <i className="bi bi-three-dots-vertical fs-5 text-dark"></i>
      </button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          elevation: 3,
          sx: {
            fontFamily: "var(--bs-font-sans-serif) !important",
            "& *": {
              fontFamily: "var(--bs-font-sans-serif) !important",
            },
            "& .MuiMenuItem-root": {
              minHeight: "28px",
              padding: "4px 12px",
            },
            "& .MuiMenuItem-root .MuiListItemText-primary": {
              fontSize: "13px !important",
              fontWeight: "500 !important",
            },
          },
        }}
      >
        {canChange && (
          <MenuItem
            component={Link}
            to={`/edit-quotation/${row.original.quotation_id}`}
            onClick={handleClose}
          >
            <ListItemIcon>
              <EditIcon fontSize="small" color="primary"/>
            </ListItemIcon>
            <ListItemText primary="Edit" />
          </MenuItem>
        )}

        <MenuItem
          onClick={() => {
            if (handleViewModal) {
              handleViewModal(row.original.quotation_id);
            } else {
              // Use React Router navigation instead of window.location.href for better performance
              navigate(`/view-quotation/${row.original.quotation_id}`);
            }
            handleClose();
          }}
        >
          <ListItemIcon>
            <VisibilityIcon fontSize="small" color="primary"/>
          </ListItemIcon>
          <ListItemText primary="View" />
        </MenuItem>

        <MenuItem
          onClick={() => {
            if (handleDownloadPDF) handleDownloadPDF(row.original.quotation_id);
            handleClose();
          }}
        >
          <ListItemIcon>
            <PictureAsPdfIcon fontSize="small" color="info" />
          </ListItemIcon>
          <ListItemText primary="Download PDF With Price" />
        </MenuItem>

        <MenuItem
          onClick={() => {
            if (handleDownloadPDF2)
              handleDownloadPDF2(row.original.quotation_id);
            handleClose();
          }}
        >
          <ListItemIcon>
            <PictureAsPdfIcon fontSize="small" color="info" />
          </ListItemIcon>
          <ListItemText primary="Download PDF Without Price" />
        </MenuItem>

        {handleFollowUpDetails && (
          <MenuItem
            onClick={() => {
              if (handleFollowUpDetails) {
                handleFollowUpDetails(row.original.quotation_id, row.original);
              }
              handleClose();
            }}
          >
            <ListItemIcon>
              <HistoryIcon fontSize="small" color="warning" />
            </ListItemIcon>
            {/* <ListItemText primary="Manage Follow-Up" sx={{ color: "primary.main" }} /> */}
            <ListItemText primary="Manage Follow-Up" />
          </MenuItem>
        )}

        <MenuItem
          onClick={() => {
            if (handlePIInvoice1) handlePIInvoice1(row.original.quotation_id);
            handleClose();
          }}
        >
          <ListItemIcon>
            <PictureAsPdfIcon fontSize="small" color="success" />
          </ListItemIcon>
          <ListItemText primary="Download PI With Price" />
        </MenuItem>

        <MenuItem
          onClick={() => {
            if (handlePIInvoice2) handlePIInvoice2(row.original.quotation_id);
            handleClose();
          }}
        >
          <ListItemIcon>
            <PictureAsPdfIcon fontSize="small" color="success" />
          </ListItemIcon>
          <ListItemText primary="Download PI Without Price" />
        </MenuItem>

        {/* <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <EmailIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Send Email" />
        </MenuItem> */}

        {/* Changed from canChange to canDelete - only show for Admin users */}
        {canDelete && (
          <MenuItem
            onClick={() => {
              if (handleDelete) handleDelete(row.original.quotation_id, row.original);
              handleClose();
            }}
            sx={{ color: "error.main" }}
          >
            <ListItemIcon>
              <DeleteIcon fontSize="small" color="error" />
            </ListItemIcon>
            <ListItemText
              primary="Delete"
              sx={{
                fontFamily: "var(--bs-font-sans-serif) !important",
                fontSize: "13px",
              }}
            />
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
